export const tableStyles = {
  container:
    'overflow-x-auto rounded-2xl border border-slate-200 bg-white/90 shadow-xl shadow-slate-200/60',
  table: 'w-full',
  header: 'bg-slate-50/80',
  headerCell:
    'px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-slate-600',
  body: 'divide-y divide-slate-100',
  row: 'hover:bg-slate-50/50',
  cell: 'px-4 py-3 text-sm whitespace-nowrap',
  sortableHeader: 'cursor-pointer select-none hover:bg-slate-100',
};

export const joinClasses = (...classes: (string | undefined | false)[]) =>
  classes.filter(Boolean).join(' ');
